import { render, staticRenderFns } from "./v-tab@.vue?vue&type=template&id=0d668fe8&"
import script from "./v-tab@.vue?vue&type=script&lang=ts&"
export * from "./v-tab@.vue?vue&type=script&lang=ts&"
import style0 from "./v-tab@.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports